module.exports = __webpack_public_path__ + "img/uncommon.8292a197.svg";